/**
 * This function is used to check if the URL is valid and has the same domain as the current URL
 * @param url The URL to check "http://sample-domain.com/path"
 * @param fullLink The full link to use if the URL is not valid "domain + /path"
 * @returns The validated URL or the full link
 */
export function checkFullLink(url, fullLink) {
    if (url && (url.includes("http") || url.includes("https"))) {
        return url;
    }
    return fullLink;
}
//# sourceMappingURL=domain.js.map